module.exports = __webpack_public_path__ + "img/eg.e362f359.png";